import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorData, type IErrorData } from '@/utils/getErrorData';
import { type PaymentCreationResponse } from '@/types/IOrderPaymentCreation';
import { type UpdatePaymentStatusResponse } from '@/types/IFetchUpdatePaymentStatus';
import { type PaymentProvidersEnum } from '@/types/PaymentProvidersEnum';
import {
  createPaymentForOrder,
  updatePaymentStatus
} from '@/hooks/orderOfferApi';
import { refreshOrderDataV2Thunk } from '@/store/order/orderThunks';
import { toast } from 'react-toastify';

export const createPaymentForOrderThunk = createAsyncThunk<
  PaymentCreationResponse,
  {
    orderUuid: string;
    providerName: PaymentProvidersEnum;
    clientId: number | null | undefined;
    amount: number | null;
    comment: string;
  },
  { rejectValue: IErrorData }
>(
  'payments/createPaymentForOrder',
  async (args, { rejectWithValue, dispatch }) => {
    const { orderUuid, providerName, clientId, amount, comment } = args;
    try {
      const response = await createPaymentForOrder(
        orderUuid,
        providerName,
        clientId,
        amount,
        comment
      );
      await dispatch(refreshOrderDataV2Thunk({ uuid: orderUuid }));
      toast.success('Платёж успешно создан');
      return response;
    } catch (error) {
      const err = getErrorData(error);
      return rejectWithValue(err);
    }
  }
);

export const updatePaymentStatusThunk = createAsyncThunk<
  UpdatePaymentStatusResponse,
  { orderUuid: string; paymentId: number; statusName: string },
  { rejectValue: IErrorData }
>(
  'payments/updatePaymentStatus',
  async (
    { orderUuid, paymentId, statusName },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await updatePaymentStatus(paymentId, statusName);
      await dispatch(refreshOrderDataV2Thunk({ uuid: orderUuid }));
      toast.success('Статус платежа обновлён');
      return response;
    } catch (error) {
      const err = getErrorData(error);
      toast.error(err.message ?? 'Не удалось обновить статус платежа');
      return rejectWithValue(err);
    }
  }
);
